import { Link as RemixLink } from '@remix-run/react';
import useTranslation from '~/i18n/i18n';
import { useUser } from '~/lib/providers/user-provider';
import { cn } from '~/lib/utils';
import { useMobileMenu } from './navbar';

export const Links = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { user } = useUser();

  return (
    <>
      {/* Only show the links if the user is authenticated */}
      {user && (
        <div className="flex flex-col lg:flex-row lg:gap-16">
          <Link
            href="/dashboard/profile"
            title={t('homePage.profile')}
            className={className}
          />
          <Link
            href="/dashboard/leaderboard"
            title={t('homePage.leaders')}
            className={className}
          />
          <Link
            href="/dashboard/tournaments"
            title={t('homePage.myTournaments')}
            className={className}
          />
          <Link
            href="/about"
            title={t('homePage.about')}
            className={className}
          />
        </div>
      )}
    </>
  );
};

interface LinkProps {
  href: string;
  title: string;
  className?: string;
}

export const Link = ({ href, title, className }: LinkProps) => {
  const { setOpen } = useMobileMenu();
  return (
    <div className="group relative h-fit">
      <RemixLink
        to={href}
        className={cn('uppercase', className)}
        onClick={() => setOpen(false)}>
        {title}
      </RemixLink>
      <span className="absolute inset-0 top-full h-px w-full bg-black opacity-0 transition-opacity group-hover:opacity-100 dark:bg-white" />
    </div>
  );
};
